import {Component, OnInit, Input, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {SearchService} from "../services/search.service";
import {NonprofitsDonorsDetailsSearchDto} from "../../../models/nonprofits-donors-details-search-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {saveAs} from "file-saver";
import {Auth2Service} from "../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {PageChangeDto} from "../../../models/page-change-dto";
import {StPagination2Component} from "../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {ReceivedGrantsSearchFilterDto} from "../../../models/received-grants-search-filter-dto";
import {jsPDF} from "jspdf";
import {autoTable} from "jspdf-autotable";
import { Base64 } from 'js-base64';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-search-donors-details',
  templateUrl: './search-donors-details.component.html',
  styleUrls: ['./search-donors-details.component.scss'],
  standalone: false
})
export class SearchDonorsDetailsComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Search Donors', path: 'app/search/donors'},
    { label: 'View Donor Details'}
  ];

  elementTags: any[] = [
    {
      "id": "donor-info-id",
      "name": "Basic Info",
      "selected": false
    },
    {
      "id": "donor-characteristics-id",
      "name": "Characteristics",
      "selected": false
    },
    {
      "id": "donor-causes-id",
      "name": "Causes",
      "selected": false
    },
    {
      "id": "donor-finances-id",
      "name": "Finances",
      "selected": false
    },
    {
      "id": "donor-key-staff-id",
      "name": "Key Staff",
      "selected": false
    },
    {
      "id": "tax-returns-id",
      "name": "Tax Returns",
      "selected": false
    },
    {
      "id": "donor-recipients-id",
      "name": "Recipients",
      "selected": false
    },
    {
      "id": "grants-received-id",
      "name": "Grants Received",
      "selected": false
    }
  ];

  @Input()
  row: any;
  nonprofitDonorId: string = '';

  companyName = '';

  nonprofitDonorFullAttr: any = {};

  organizationCode: string = '';

  foundationCode: string = '';

  nteeParentCode: string = '';

  nteeCode: string = '';

  rulingDate: number = 0;

  establishedYear: number = 0;

  returnTypeCode: string = '';

  causesDonatedTo: string[] = [];
  causesDonatedToPreview: string[] = [];

  mostRecentDonorDetailsId: number = -1;

  selectedTaxYear: number = -1;

  donorRecipientMappingRows: any[] = [];
  otherGrantsDtos: any[] = [];

  miscGrantsDtos: any[] = [];

  recievedDonorRecipientMappingRows: any[] = [];

  companyFinancialsByYear: any[] = [];
  companyPDFsByYear: any[] = [];

  viewCausePanelVisible: boolean = false;

  truncMaxLength: number = 300;

  sortedAscRecipientOfGrant: boolean = false;
  sortedAscCity: boolean = false;
  sortedAscState: boolean = false;
  sortedAscCashGrantAmt: boolean = false;

  sortedAscRecipientOfGrantId: number = 0;
  sortedAscCityId: number = 0;
  sortedAscStateId: number = 0;
  sortedAscCashGrantAmtId: number= 0;

  sortedAscReceivedDonor: boolean = false;
  sortedAscReceivedRecipientOfGrant: boolean = false;
  sortedAscReceivedCity: boolean = false;
  sortedAscReceivedState: boolean = false;
  sortedAscReceivedCashGrantAmt: boolean = false;

  sortedAscReceivedDonorId: number = 0;
  sortedAscReceivedRecipientOfGrantId: number = 0;
  sortedAscReceivedCityId: number = 0;
  sortedAscReceivedStateId: number = 0;
  sortedAscReceivedCashGrantAmtId: number = 0;

  @ViewChild('donatedtorecipientspaginator') stPaginator2DonatedToRecipientsComponent!: StPagination2Component;
  donatedToRecipientsTaxYears: any[] = [];
  donatedToRecipientsTaxYear: number = 0;
  donatedToRecipientsLoadingIcon: boolean = false;
  donatedToRecipientsCollectionSize: number = 0;
  donatedToRecipientsPage: number = 1;
  donatedToRecipientsPageSize: number = 25;
  donatedToRecipientsCustomPageSizes: any[] = [
    {
      "pageSizeId" : 25,
      "pageSize": 25
    }, {
      "pageSizeId" : 50,
      "pageSize": 50
    }, {
      "pageSizeId" : 100,
      "pageSize": 100
    }, {
      "pageSizeId" : 250,
      "pageSize": 250
    }
  ];


  @ViewChild('receivedgrantspaginator') stPaginator2ReceivedGrantsComponent!: StPagination2Component;
  receivedGrantsTaxYears: any[] = [];
  receivedGrantsTaxYear = 0;
  receivedGrantsLoadingIcon: boolean = false;
  receivedGrantsCollectionSize: number = 0;
  receivedGrantsPage: number = 1;
  receivedGrantsPageSize: number = 25;
  receivedGrantsCustomPageSizes: any[] = [
    {
      "pageSizeId" : 25,
      "pageSize": 25
    }, {
      "pageSizeId" : 50,
      "pageSize": 50
    }, {
      "pageSizeId" : 100,
      "pageSize": 100
    }, {
      "pageSizeId" : 250,
      "pageSize": 250
    }
  ];

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  emailCodeVerifiedFlag: string = 'N';
  //Needs pop up for Donor Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private searchService: SearchService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy View Donors Details")
  }

  ngOnInit(): void {
    if (window.location.href.includes('grants')) {
      this.breadCrumbs = [
        { iconClass: 'bi-house', path: '/app/users/dashboard'},
        { label: 'Home', path: '/app/users/dashboard'},
        { label: 'Your Dashboard', path: 'app/users/dashboard'},
        { label: 'Search Grants', path: 'app/search/grants'},
        { label: 'View Donor Details'}
      ]
    }
    // @ts-ignore
    this.nonprofitDonorId = this.route.snapshot.paramMap.get('nonprofitDonorId');
    // @ts-ignore
    const searchDto: NonprofitsDonorsDetailsSearchDto = {
      'nonprofitDonorId': parseInt(this.nonprofitDonorId),
      'taxYears': [],
      'sortByRecipientNameAsc': 0,
      'sortByCityAsc': 0,
      'sortByStateAsc': 0,
      'sortByGrantAmtAsc': 2
    }

    const searchDto2: ReceivedGrantsSearchFilterDto = {
      'nonprofitDonorId': parseInt(this.nonprofitDonorId),
      'taxYears': [],
      'sortByReceivedDonorNameAsc': 0,
      'sortByReceivedRecipientNameAsc': 0,
      'sortByReceivedCityAsc': 0,
      'sortByReceivedStateAsc': 0,
      'sortByReceivedGrantAmtAsc': 2
    }

    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    this.emailCodeVerifiedFlag = this.auth2ServiceChild.getEmailCodeVerifiedFlag();
    if (this.emailCodeVerifiedFlag != 'Y') {
      this.routerChild.navigateByUrl('app/users/emails/verify')
      return;
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
      // @ts-ignore
      this.searchService.getNonprofitDonorFullAttributes(parseInt(this.nonprofitDonorId), this.username).subscribe(
        (result : any) => {
          if (result && result.body) {
            this.nonprofitDonorFullAttr = result.body;

            this.rulingDate = this.nonprofitDonorFullAttr['rulingDate'];
            this.establishedYear = this.nonprofitDonorFullAttr['establishedYear'];
            this.organizationCode = 'N/A';
            if (this.nonprofitDonorFullAttr['organizationCode']) {
              this.organizationCode = this.nonprofitDonorFullAttr['organizationCode'].description;
            }
            this.foundationCode = 'N/A';
            if (this.nonprofitDonorFullAttr['foundationCode']) {
              this.foundationCode = this.nonprofitDonorFullAttr['foundationCode'].description;
            }
            this.nteeParentCode = 'N/A';
            if (this.nonprofitDonorFullAttr['nteeParentCode']) {
              this.nteeParentCode = this.nonprofitDonorFullAttr['nteeParentCode'].description;
            }
            this.nteeCode = 'N/A';
            if (this.nonprofitDonorFullAttr['nteeCode']) {
              this.nteeCode = this.nonprofitDonorFullAttr['nteeCode'].nteeCode + ': ' + this.nonprofitDonorFullAttr['nteeCode'].description;
            }
            this.returnTypeCode = 'N/A';
            if (this.nonprofitDonorFullAttr['returnTypeCode']) {
              this.returnTypeCode = this.nonprofitDonorFullAttr['returnTypeCode'].returnTypeCodeName;
            }
            this.causesDonatedTo = [];
            this.causesDonatedToPreview = [];
            if (this.nonprofitDonorFullAttr['donatedCausesTxt']) {
              this.causesDonatedTo = this.nonprofitDonorFullAttr['donatedCausesTxt'];
              let count: number = 0;
              for (const cause of this.causesDonatedTo) {
                if (count > 15) {
                  break;
                }
                this.causesDonatedToPreview.push(cause);
                count = count + 1;
              }
            }
            this.processWebsiteURL();
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Donor API Error:',
            detail: 'Failed to pull the Donor\'s information...',
            severity: 'error'
          })
          this.showPageErrorMessagesToUser();
        }
      );

      this.populateTaxYearsDropdown();

      // @ts-ignore
      this.searchService.getOrganizationIRSTaxReturnPDFs(parseInt(this.nonprofitDonorId), this.username).subscribe((pdfResult: any) => {
        if (pdfResult && pdfResult.body) {
          this.companyPDFsByYear = pdfResult.body;
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Donor API Error:',
          detail: 'Failed to pull the Donor\'s IRS PDFs...',
          severity: 'error'
        })
        this.showPageErrorMessagesToUser();
      });

      // @ts-ignore
      this.searchService.getDonorDetails(searchDto, this.nonprofitDonorId, this.username).subscribe((result: any) => {
        if (result && result.body) {
          this.companyFinancialsByYear = result.body.organizationDetailsDtoList;

          for (const companyFinancialRow of this.companyFinancialsByYear) {
            if (companyFinancialRow.taxYear >= this.selectedTaxYear) {
              this.selectedTaxYear = companyFinancialRow.taxYear;
              this.donatedToRecipientsTaxYear = this.selectedTaxYear;
              this.receivedGrantsTaxYear = this.selectedTaxYear;
              this.mostRecentDonorDetailsId = companyFinancialRow.donorDetailsId;
            }
          }
          this.donatedToRecipientsLoadingIcon = true;
          this.receivedGrantsLoadingIcon = true;
          // @ts-ignore
          this.searchService.getDonorDetailsRecipientsPages(searchDto, this.donatedToRecipientsPage,
            this.donatedToRecipientsPageSize, this.username).subscribe((result2: any) => {
            if (result2 && result2.body) {
              this.donorRecipientMappingRows = result2.body.dtos;
              //console.log('this.donorRecipientMappingRows: ' + JSON.stringify(this.donorRecipientMappingRows))
              this.donatedToRecipientsPage = 1;
              this.donatedToRecipientsPageSize = result2.body.pageSize;
              this.donatedToRecipientsCollectionSize = result2.body.collectionSize;
              this.otherGrantsDtos = result2.body.otherGrantsDtos;
              this.miscGrantsDtos = result2.body.miscGrantsDtos;
              this.stPaginator2DonatedToRecipientsComponent.initPages(this.donatedToRecipientsCollectionSize,
                this.donatedToRecipientsPageSize);
            }
            this.donatedToRecipientsLoadingIcon = false;
          }, (err: HttpErrorResponse) => {
            this.redirectToLogin(err);
            this.pageErrorMessages.push({
              field: 'Donor API Error:',
              detail: 'Failed to pull the Donor\'s recipients...',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser();
            this.donatedToRecipientsLoadingIcon = false;
          });

          // @ts-ignore
          this.searchService.getReceivedGrantsPages(searchDto2, this.receivedGrantsPage,
            this.donatedToRecipientsPageSize, this.username).subscribe((result3: any) => {
            if (result3 && result3.body) {
              //this.donorRecipientMappingRows = result2.body;
              this.recievedDonorRecipientMappingRows = result3.body.dtos;
              this.receivedGrantsPage = 1
              this.receivedGrantsPageSize = result3.body.pageSize;
              this.receivedGrantsCollectionSize = result3.body.collectionSize;
              this.stPaginator2ReceivedGrantsComponent.initPages(this.receivedGrantsCollectionSize,
                this.receivedGrantsPageSize);
            }
            this.receivedGrantsLoadingIcon = false;
          }, (err: HttpErrorResponse) => {
            this.redirectToLogin(err);
            this.pageErrorMessages.push({
              field: 'Donor API Error:',
              detail: 'Failed to pull the organization\'s received grants...',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser();
            this.receivedGrantsLoadingIcon = false;
          });

        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Donor API Error:',
          detail: 'Failed to pull the Donor\'s Information...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.donatedToRecipientsLoadingIcon = false;
        this.receivedGrantsLoadingIcon = false;
      });
    }

  }

  toggleViewCausePanel(): boolean {
    this.viewCausePanelVisible = !this.viewCausePanelVisible;
    return this.viewCausePanelVisible;
  }

  private processWebsiteURL() {
    if (this.nonprofitDonorFullAttr['websiteURL'] == 'N/A' || this.nonprofitDonorFullAttr['websiteURL'] == 'n/a' || !this.nonprofitDonorFullAttr['websiteURL']) {
      this.nonprofitDonorFullAttr['websiteURL'] = 'N/A';
    } else {
      if (!this.nonprofitDonorFullAttr['websiteURL'].startsWith('http')) {
        this.nonprofitDonorFullAttr['websiteURL'] = 'https://' + this.nonprofitDonorFullAttr['websiteURL']
      }
    }
  }

  populateTaxYearsDropdown(): void {
    this.searchService.getTaxYearsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.donatedToRecipientsTaxYears = result.body;
        this.receivedGrantsTaxYears = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Failed to fetch the Tax Years',
        detail: 'Failed to fetch the Tax Years. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  formatPhoneNumber(inputStr: string): string {
    return this.apiService.formatPhoneNumber(inputStr);
  }

  formatEin(inputStr: string): string {
    return this.apiService.formatEin(inputStr);
  }

  formatZipCode(inputStr: string): string {
    return this.apiService.formatZipCode(inputStr);
  }

  toggleCompanyFinancialsPanel(companyFinancialsRow: any): boolean {
    companyFinancialsRow.visible = !companyFinancialsRow.visible;
    return companyFinancialsRow.visible;
  }

  /*
  onExportToExcel(): any {
    // @ts-ignore
    const nonprofitDonorId: string = this.route.snapshot.paramMap.get('nonprofitDonorId');
    const username = localStorage.getItem('username');
    // @ts-ignore
    this.searchService.getDonorFullReportForExcel(nonprofitDonorId, username).subscribe(
      (result: any) => {
        if (result && result.body) {
          saveAs(result.body,'donor_full_report.xlsx');
        }
      }, (err: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Donor API Error:',
          detail: 'Failed to download the Donor\'s Excel...',
          severity: 'error'
        })
        this.showPageErrorMessagesToUser();
      }
    );
    return true;
  }*/

  changePageResultsReceivedGrants(pageChangeDto: PageChangeDto) {
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.receivedGrantsPageSize = pageChangeDto["pageSize"]
    }
    //console.log('pageChangeDto: ' + JSON.stringify(pageChangeDto));
    this.receivedGrantsLoadingIcon = true;
    const taxYears: number[] = [];
    let taxYearChanged: boolean = false;
    const receivedGrantsTaxYearEl = document.getElementById('received-grants-tax-year-list-id');
    // @ts-ignore
    const taxYearSelected = receivedGrantsTaxYearEl.value;
    if (taxYearSelected) {
      if (taxYearSelected != this.receivedGrantsTaxYear) {
        taxYearChanged = true;
        updatePageValue = 1;// because the year changed, restart at page 1 for stability
      }
      this.receivedGrantsTaxYear = taxYearSelected;
      taxYears.push(this.receivedGrantsTaxYear);
    }

    // @ts-ignore
    const searchDto: ReceivedGrantsSearchFilterDto = {
      'nonprofitDonorId': parseInt(this.nonprofitDonorId),
      'taxYears': taxYears,
      'sortByReceivedDonorNameAsc': this.sortedAscReceivedDonorId,
      'sortByReceivedRecipientNameAsc': this.sortedAscReceivedRecipientOfGrantId,
      'sortByReceivedCityAsc': this.sortedAscReceivedCityId,
      'sortByReceivedGrantAmtAsc': this.sortedAscReceivedCashGrantAmtId
    }

    this.searchService.getReceivedGrantsPages(searchDto, updatePageValue, this.receivedGrantsPageSize, this.username)
      .subscribe((result : any) => {
        if (result && result.body) {
          this.recievedDonorRecipientMappingRows = result.body.dtos;
          this.receivedGrantsPage = updatePageValue;
          if (result.body.taxYear > 0) {
            this.receivedGrantsTaxYear = result.body.taxYear;
            // @ts-ignore
            receivedGrantsTaxYearEl.value = this.receivedGrantsTaxYear;
          }
          this.receivedGrantsPageSize = result.body.pageSize;
          this.receivedGrantsCollectionSize = result.body.collectionSize
          if (taxYearChanged) {
            this.stPaginator2ReceivedGrantsComponent.initPages(this.receivedGrantsCollectionSize,
              this.receivedGrantsPageSize);
          }
        }
        this.receivedGrantsLoadingIcon = false;
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Grants Received Retrieval Error',
          detail: 'Failed to pull the grants received by this organization. Please try again.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.receivedGrantsLoadingIcon = false;
      });
  }
  changePageResultsDonatedToRecipients(pageChangeDto: PageChangeDto) {
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.donatedToRecipientsPageSize = pageChangeDto["pageSize"]
    }
    //console.log('pageChangeDto: ' + JSON.stringify(pageChangeDto));
    this.donatedToRecipientsLoadingIcon = true;

    const taxYears: number[] = [];
    let taxYearChanged: boolean = false;
    const donatedToRecipientsTaxYearEl = document.getElementById('donated-to-recipients-tax-year-list-id');
    // @ts-ignore
    const taxYearSelected = donatedToRecipientsTaxYearEl.value;
    if (taxYearSelected) {
      if (taxYearSelected != this.donatedToRecipientsTaxYear) {
        taxYearChanged = true;
        updatePageValue = 1;// because the year changed, restart at page 1 for stability
      }
      this.donatedToRecipientsTaxYear = taxYearSelected;
      taxYears.push(this.donatedToRecipientsTaxYear);
    }

    // @ts-ignore
    const searchDto: NonprofitsDonorsDetailsSearchDto = {
      'nonprofitDonorId': parseInt(this.nonprofitDonorId),
      'taxYears': taxYears,
      'sortByRecipientNameAsc': this.sortedAscRecipientOfGrantId,
      'sortByCityAsc': this.sortedAscCityId,
      'sortByStateAsc': this.sortedAscStateId,
      'sortByGrantAmtAsc': this.sortedAscCashGrantAmtId
    }

    this.searchService.getDonorDetailsRecipientsPages(searchDto, updatePageValue, this.donatedToRecipientsPageSize, this.username)
      .subscribe((result : any) => {
        if (result && result.body) {
          this.donorRecipientMappingRows = result.body.dtos;
          this.donatedToRecipientsPage = updatePageValue
          if (result.body.taxYear > 0) {
            this.donatedToRecipientsTaxYear = result.body.taxYear;
            // @ts-ignore
            donatedToRecipientsTaxYearEl.value = this.donatedToRecipientsTaxYear;
          }
          this.donatedToRecipientsPageSize = result.body.pageSize;
          this.donatedToRecipientsCollectionSize = result.body.collectionSize
          this.otherGrantsDtos = result.body.otherGrantsDtos;
          this.miscGrantsDtos = result.body.miscGrantsDtos;
          if (taxYearChanged) {
            this.stPaginator2DonatedToRecipientsComponent.initPages(this.donatedToRecipientsCollectionSize,
              this.donatedToRecipientsPageSize);
          }
        }
        this.donatedToRecipientsLoadingIcon = false;
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Recipients Retrieval Error',
          detail: 'Failed to pull the grants donated to recipients. Please try again.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.donatedToRecipientsLoadingIcon = false;
      });
  }

  onBack() {
    this.routerChild.navigateByUrl(this.nonprofitDonorFullAttr.nonprofitDonorId ? 'app/search/donors' : 'home');
  }

  reloadRecipientsWithNewSort(): void {
    const taxYears: number[] = []
    const donatedToRecipientsTaxYearEl = document.getElementById('donated-to-recipients-tax-year-list-id');
    // @ts-ignore
    const taxYearSelected = donatedToRecipientsTaxYearEl.value;
    if (taxYearSelected) {
      this.donatedToRecipientsTaxYear = taxYearSelected;
    }
    taxYears.push(this.donatedToRecipientsTaxYear);

    const searchDto: NonprofitsDonorsDetailsSearchDto = {
      'nonprofitDonorId': parseInt(this.nonprofitDonorId),
      'taxYears': taxYears,
      'sortByRecipientNameAsc': this.sortedAscRecipientOfGrantId,
      'sortByCityAsc': this.sortedAscCityId,
      'sortByStateAsc': this.sortedAscStateId,
      'sortByGrantAmtAsc': this.sortedAscCashGrantAmtId
    }
    this.donatedToRecipientsLoadingIcon = true;

    this.donatedToRecipientsPage = 1;

    // @ts-ignore
    this.searchService.getDonorDetailsRecipientsPages(searchDto, this.donatedToRecipientsPage,
      this.donatedToRecipientsPageSize, this.username).subscribe((result2: any) => {
      if (result2 && result2.body) {
        this.donorRecipientMappingRows = result2.body.dtos;
        this.donatedToRecipientsPage = 1;
        this.donatedToRecipientsPageSize = result2.body.pageSize;
        this.donatedToRecipientsCollectionSize = result2.body.collectionSize;
        this.otherGrantsDtos = result2.body.otherGrantsDtos;
        this.miscGrantsDtos = result2.body.miscGrantsDtos;
        this.stPaginator2DonatedToRecipientsComponent.initPages(this.donatedToRecipientsCollectionSize,
          this.donatedToRecipientsPageSize);
      }
      this.donatedToRecipientsLoadingIcon = false;
    }, (err: HttpErrorResponse) => {
      this.redirectToLogin(err);
      this.pageErrorMessages.push({
        field: 'Donor API Error:',
        detail: 'Failed to pull the Donor\'s recipients...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.donatedToRecipientsLoadingIcon = false;
    });
  }
  sortTextRecipientOfGrantName(): void {
    if (!this.sortedAscRecipientOfGrant) {
      this.sortedAscRecipientOfGrantId = 2;
      this.sortedAscCityId = 0;
      this.sortedAscStateId = 0;
      this.sortedAscCashGrantAmtId = 0;
    } else {
      this.sortedAscRecipientOfGrantId = 1;
      this.sortedAscCityId = 0;
      this.sortedAscStateId = 0;
      this.sortedAscCashGrantAmtId = 0;
    }
    this.reloadRecipientsWithNewSort();
    this.sortedAscRecipientOfGrant = !this.sortedAscRecipientOfGrant
  }

  sortTextCity(): void {
    if (!this.sortedAscCity) {
      this.sortedAscRecipientOfGrantId = 0;
      this.sortedAscCityId = 2;
      this.sortedAscStateId = 0;
      this.sortedAscCashGrantAmtId = 0;
    } else {
      this.sortedAscRecipientOfGrantId = 0;
      this.sortedAscCityId = 1;
      this.sortedAscStateId = 0;
      this.sortedAscCashGrantAmtId = 0;
    }
    this.reloadRecipientsWithNewSort();
    this.sortedAscCity = !this.sortedAscCity;
  }

  sortTextState(): void {
    if (!this.sortedAscState) {
      this.sortedAscRecipientOfGrantId = 0;
      this.sortedAscCityId = 0;
      this.sortedAscStateId = 2;
      this.sortedAscCashGrantAmtId = 0;
    } else {
      this.sortedAscRecipientOfGrantId = 0;
      this.sortedAscCityId = 0;
      this.sortedAscStateId = 1;
      this.sortedAscCashGrantAmtId = 0;
    }
    this.reloadRecipientsWithNewSort();
    this.sortedAscState = !this.sortedAscState;
  }

  sortNumberCashGrantAmt(): void {
    if (!this.sortedAscCashGrantAmt) {
      this.sortedAscRecipientOfGrantId = 0;
      this.sortedAscCityId = 0;
      this.sortedAscStateId = 0;
      this.sortedAscCashGrantAmtId = 2;
    } else {
      this.sortedAscRecipientOfGrantId = 0;
      this.sortedAscCityId = 0;
      this.sortedAscStateId = 0;
      this.sortedAscCashGrantAmtId = 1;
    }
    this.reloadRecipientsWithNewSort();
    this.sortedAscCashGrantAmt = !this.sortedAscCashGrantAmt
  }

  reloadReceivedGrantsWithNewSort(): void {
    this.receivedGrantsLoadingIcon = true;
    const taxYears: number[] = [];
    const receivedGrantsTaxYearEl = document.getElementById('received-grants-tax-year-list-id');
    // @ts-ignore
    const taxYearSelected = receivedGrantsTaxYearEl.value;
    if (taxYearSelected) {
      //It is possible for tax year to not be selected in the dropdown box
      this.receivedGrantsTaxYear = taxYearSelected;
    }
    taxYears.push(this.receivedGrantsTaxYear);

    const searchDto: ReceivedGrantsSearchFilterDto = {
      'nonprofitDonorId': parseInt(this.nonprofitDonorId),
      'taxYears': taxYears,
      'sortByReceivedDonorNameAsc': this.sortedAscReceivedDonorId,
      'sortByReceivedRecipientNameAsc': this.sortedAscReceivedRecipientOfGrantId,
      'sortByReceivedCityAsc': this.sortedAscReceivedCityId,
      'sortByReceivedStateAsc': this.sortedAscReceivedStateId,
      'sortByReceivedGrantAmtAsc': this.sortedAscReceivedCashGrantAmtId
    }
    this.receivedGrantsPage = 1;
    // @ts-ignore
    this.searchService.getReceivedGrantsPages(searchDto, this.receivedGrantsPage,
      this.receivedGrantsPageSize, this.username).subscribe((result3: any) => {
      if (result3 && result3.body) {
        //this.donorRecipientMappingRows = result2.body;
        this.recievedDonorRecipientMappingRows = result3.body.dtos;
        this.receivedGrantsPage = 1
        this.receivedGrantsPageSize = result3.body.pageSize;
        this.receivedGrantsCollectionSize = result3.body.collectionSize;
        this.stPaginator2ReceivedGrantsComponent.initPages(this.receivedGrantsCollectionSize,
          this.receivedGrantsPageSize);
      }
      this.receivedGrantsLoadingIcon = false;
    }, (err: HttpErrorResponse) => {
      this.redirectToLogin(err);
      this.pageErrorMessages.push({
        field: 'Donor API Error:',
        detail: 'Failed to pull the organization\'s received grants...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.receivedGrantsLoadingIcon = false;
    });
  }

  sortTextReceivedDonorName(): void {
    if (!this.sortedAscReceivedDonor) {
      this.sortedAscReceivedDonorId = 2;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 0;
    } else {
      this.sortedAscReceivedDonorId = 1;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 0;
    }
    this.reloadReceivedGrantsWithNewSort();
    this.sortedAscReceivedDonor = !this.sortedAscReceivedDonor
  }

  sortTextReceivedRecipientOfGrantName(): void {
    if (!this.sortedAscReceivedRecipientOfGrant) {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 2;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 0;
    } else {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 1;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 0;
    }
    this.reloadReceivedGrantsWithNewSort();
    this.sortedAscReceivedRecipientOfGrant = !this.sortedAscReceivedRecipientOfGrant
  }

  sortTextReceivedCity(): void {
    if (!this.sortedAscReceivedCity) {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 2;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 0;
    } else {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 1;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 0;
    }
    this.reloadReceivedGrantsWithNewSort();
    this.sortedAscReceivedCity = !this.sortedAscReceivedCity;
  }

  sortTextReceivedState(): void {
    if (!this.sortedAscReceivedState) {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 2;
      this.sortedAscReceivedCashGrantAmtId = 0;
    } else {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 1;
      this.sortedAscReceivedCashGrantAmtId = 0;
    }
    this.reloadReceivedGrantsWithNewSort();
    this.sortedAscReceivedState = !this.sortedAscReceivedState;
  }

  sortNumberReceivedCashGrantAmt(): void {
    if (!this.sortedAscReceivedCashGrantAmt) {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 2;
    } else {
      this.sortedAscReceivedDonorId = 0;
      this.sortedAscReceivedRecipientOfGrantId = 0;
      this.sortedAscReceivedCityId = 0;
      this.sortedAscReceivedStateId = 0;
      this.sortedAscReceivedCashGrantAmtId = 1;
    }
    this.reloadReceivedGrantsWithNewSort();
    this.sortedAscReceivedCashGrantAmt = !this.sortedAscReceivedCashGrantAmt
  }

  onViewRecipientDetails(row: any): void {
    const url = `/app/search/grants/donors/${row.donorRecipientMappingId}/recipients/${row.recipientId}/details`;
    // @ts-ignore
    window.open(url, '_blank').focus();
  }
  onViewDonorDetails(row: any): void {
    const url = `/app/search/donors/${row.donorId}/details`;
    // @ts-ignore
    window.open(url, '_blank').focus();
  }

  generateSearchablePdf() {
    // Create a new PDF document.
    const doc = new jsPDF();
    let now = new Date();
    const img = new Image();
    img.src = 'assets/images/Scalanthropy_logo.png'
    let y: number = 10;
    doc.addImage(img, 'PNG', 10, y, 50, 20);
    y = y + 30;

    doc.setFontSize(16).setFont("Helvetica", "bold").text("Donor Information:", 10, y)
    y = y + 10;
    doc.setFontSize(12);
    let companyNameLabelText: string = "Company Name: ";
    doc.setFont("Helvetica", "bold").text(companyNameLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['companyName'], 55, y);
    y = y + 10;
    let einLabelText: string = "EIN: ";
    doc.setFont("Helvetica", "bold").text(einLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.formatEin(this.nonprofitDonorFullAttr['ein']), 55, y);
    y = y + 10;
    let phoneNumberLabelText: string = "Phone Number: ";
    doc.setFont("Helvetica", "bold").text(phoneNumberLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.formatPhoneNumber(this.nonprofitDonorFullAttr['phoneNumber']), 55, y);
    y = y + 10;
    let emailLabelText: string = "Email: ";
    doc.setFont("Helvetica", "bold").text(emailLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['email'], 55, y);
    y = y + 10;

    let websiteUrlLabelText: string = "Website URL: ";
    if (this.nonprofitDonorFullAttr['websiteURL'] == 'N/A') {
      doc.setFont("Helvetica", "bold").text(websiteUrlLabelText, 10, y)
        .setFont("Helvetica", "normal").text("No Website Available - We Recommend Calling", 55, y);
    } else {
      doc.setFont("Helvetica", "bold").text(websiteUrlLabelText, 10, y)
        .setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['websiteURL'], 55, y);
    }
    y = y + 10;

    doc.setFont("Helvetica", "bold").text("Address (Based on Latest Tax Return): ", 10, y);
    y = y + 5;
    if (this.nonprofitDonorFullAttr['taxFilingStreetAddress']) {
      doc.setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['taxFilingStreetAddress'], 10, y);
      y = y + 5;
      doc.setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['taxFilingCity'] + ", " + this.nonprofitDonorFullAttr['taxFilingState'] + ", " + this.nonprofitDonorFullAttr['taxFilingCountry'] + ", " + this.nonprofitDonorFullAttr['taxFilingZipCode'], 10, y);
    } else {
      doc.setFont("Helvetica", "normal").text("N/A", 10, y);
    }
    y = y + 10;

    doc.setFont("Helvetica", "bold").text("Other Known Address: ", 10, y);
    y = y + 5;
    if (this.nonprofitDonorFullAttr['streetAddress']) {
      doc.setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['streetAddress'], 10, y);
      y = y + 5;
      doc.setFont("Helvetica", "normal").text(this.nonprofitDonorFullAttr['city'] + ", " + this.nonprofitDonorFullAttr['state'] + ", " + this.nonprofitDonorFullAttr['country'] + ", " + this.nonprofitDonorFullAttr['zipCode'], 10, y);
    } else {
      doc.setFont("Helvetica", "normal").text("N/A", 10, y);
    }
    y = y + 10;

    doc.setFontSize(16).setFont("Helvetica", "bold").text("Donor Characteristics: ", 10, y);
    y = y + 10;
    doc.setFontSize(12);
    let orgCodeLabelText: string = "Organization Code: ";
    if (this.organizationCode) {
      doc.setFont("Helvetica", "bold").text(orgCodeLabelText, 10, y)
        .setFont("Helvetica", "normal").text(this.organizationCode,
        55, y);
    } else {
      doc.setFont("Helvetica", "bold").text(orgCodeLabelText, 10, y)
        .setFont("Helvetica", "normal").text("N/A",
        55, y);
    }
    y = y + 5;

    let foundationCodeLabelText: string = "Foundation Code: ";
    if (this.foundationCode) {
      if (this.foundationCode == null || this.foundationCode == '') {
        this.foundationCode = 'N/A';
      }
      let foundationCodeLength: number = this.foundationCode.length;
      if (foundationCodeLength > 65) {
        //Build array of string for the sake of line wrapping
        let h: number = 0;
        let truncLength: number = 0;
        let truncFoundationCodeTxt: string = '';
        if (foundationCodeLength >= this.truncMaxLength) {
          truncFoundationCodeTxt = this.foundationCode.slice(0, this.truncMaxLength);
          truncLength = this.truncMaxLength;
        } else {
          truncFoundationCodeTxt = this.foundationCode;
          truncLength = foundationCodeLength;
        }
        let linesMax: number = Math.ceil(truncLength / 65);
        doc.setFont("Helvetica", "bold").text(foundationCodeLabelText, 10, y)
        let lastIndex: number = linesMax - 1;
        while (h < linesMax) {
          let charCount: number = (h+1)*65;
          if (truncLength <= charCount) {
            charCount = truncLength;
          }
          let subFoundationCode: string = truncFoundationCodeTxt.slice(h*65, charCount);
          if (h < lastIndex) {
            subFoundationCode = subFoundationCode + '-';
          }
          doc.setFont("Helvetica", "normal").text(subFoundationCode, 55, y);
          y = y + 5;
          h = h + 1;
        }
      } else {
        doc.setFont("Helvetica", "bold").text(foundationCodeLabelText, 10, y)
          .setFont("Helvetica", "normal").text(this.foundationCode, 55, y);
      }
    } else {
      doc.setFont("Helvetica", "bold").text(foundationCodeLabelText, 10, y)
        .setFont("Helvetica", "normal").text("N/A", 55, y);
    }

    y = y + 5;

    let nteeParentCodeLabelText: string = "NTEE Parent Code: ";
    if (this.nteeParentCode) {
      doc.setFont("Helvetica", "bold").text(nteeParentCodeLabelText, 10, y)
        .setFont("Helvetica", "normal").text(this.nteeParentCode, 55, y);
    } else {
      doc.setFont("Helvetica", "bold").text(nteeParentCodeLabelText, 10, y)
        .setFont("Helvetica", "normal").text("N/A", 55, y);
    }
    y = y + 5;

    let nteeCodeLabelText: string = "NTEE Code: ";
    doc.setFont("Helvetica", "bold").text(nteeCodeLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.nteeCode, 55, y);
    y = y + 5;

    let returnTypeCodeLabelText: string = "Return Type Code: ";
    doc.setFont("Helvetica", "bold").text(returnTypeCodeLabelText, 10, y)
      .setFont("Helvetica", "normal").text(this.returnTypeCode, 55, y);
    y = y + 10;

    doc.setFont("Helvetica", "bold").text("Causes: ", 10, y);
    y = y + 5;
    let causeMax: number = 15;
    let causeCount: number = 0;
    for (const causeRow of this.causesDonatedTo) {
      doc.setFont("Helvetica", "normal").text(">  " + causeRow, 10, y);
      y = y + 5;
      causeCount = causeCount + 1;
      if (causeMax <= causeCount) {
        break;
      }
    }
    doc.setFont("Helvetica", "bold").text("Please refer back to website for full list of causes.", 10, y);
    let cfbyLength1: number = this.companyFinancialsByYear.length;
    if (cfbyLength1 > 0) {
      doc.addPage();
      y = 10;
      y = y + 10;

      let j: number = 0;
      for (const row of this.companyFinancialsByYear) {
        let donorFinancialsLabelText: string = "Donor Financials for ";
        //Loop through all tax returns but only display the Key Staff for the most recent tax return since the list is huge
        doc.setFontSize(16).setFont("Helvetica", "bold").text(donorFinancialsLabelText + row['taxYear'].toString(), 10, y);
        y = y + 10;

        doc.setFontSize(12);
        let donorTotalRevenueLabelText: string = "Total Revenue: ";
        doc.setFont("Helvetica", "bold").text(donorTotalRevenueLabelText, 10, y)
          .setFont("Helvetica", "normal").text(row['totalRevenueFormatted'],
          55, y);
        y = y + 5;

        let donorTotalExpensesLabelText: string = "Total Expenses: ";
        doc.setFont("Helvetica", "bold").text(donorTotalExpensesLabelText, 10, y)
          .setFont("Helvetica", "normal").text(row['totalExpensesFormatted'],
          55, y);
        y = y + 5;

        let donorTotalAssetsLabelText: string = "Total Assets: ";
        doc.setFont("Helvetica", "bold").text(donorTotalAssetsLabelText, 10, y)
          .setFont("Helvetica", "normal").text(row['totalAssetsFormatted'],
          55, y);
        y = y + 10;

        if (j >= 4) {
          break;
        }
        j = j + 1;
      }
      //Only display the latest Key Employee since the list is huge
      doc.addPage();
      y = 10;

      //Insert Table
      let head: any[] = [["Name", "Title", "Phone Number"]];
      const body: any[] = [];
      let cfbyLength: number = this.companyFinancialsByYear.length
      if (cfbyLength > 0) {
        let donorFinancialsLabelText: string = "Donor Key Staff for ";
        //Loop through all tax returns but only display the Key Staff for the most recent tax return since the list is huge
        doc.setFont("Helvetica", "bold").text(donorFinancialsLabelText + this.companyFinancialsByYear[0]['taxYear'].toString(), 10, y);
        y = y + 6;

        for (const keyEmployee of this.companyFinancialsByYear[0]['keyEmployeesList']) {
          body.push([keyEmployee['personName'], keyEmployee['titleTxt'], keyEmployee['phoneNum']]);
        }
        autoTable(doc, {
          head: head,
          body: body,
          startY: y, // Start Y position
          theme: 'striped', // 'striped', 'grid', 'plain'
          styles: {
            fontSize: 10,
            cellPadding: 3
          },
          headStyles: {
            fillColor: [200, 200, 200],
            textColor: [0, 0, 0]
          }
        });
      }
    }
    doc.setFont("Helvetica", "normal").text(
      "Copyright Scalanthropy " + now.getFullYear().toString(), 150, 290);
    doc.save('donor_details_document.pdf');
  }

}
